import React, {useEffect, useState} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const ReasonsContent = ({data, boName}) => {
    const [limit, setLimit] = useState(15)
    const passedLimit = data.reasonsBo.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prevState => prevState ? null : 15)
    }

    useEffect(() => {
        const labels = ["Representação", "Quantidade", "Natureza", "Grupo"];
        const values = [];

        const sorted = [...(data.reasonsBo || [])];

        sorted.forEach((item) => {
            values.push([
                `${item.percent}%`,
                item.amount,
                item.reasons,
                item.groups
            ]);
        });

        ReportUtils.createExportableTable(labels, values, `${boName} por natureza`);
    }, [data]);

    return (
        <>
            <div id="nature-table">
                <div className="chart mt-3">
                    <span id="nature-title" className="chart-title">
                        {data.boName} por natureza {(passedLimit && limit) ? "(TOP 15)" : ""}
                    </span>
                </div>

                <table className="table report-table mt-2">
                    <thead className="thead-background">
                        <tr className={"text-left"}>
                            <th className={'w-[13%]'}>Representação</th>
                            <th>Quantidade</th>
                            <th>Natureza</th>
                            <th>Grupo</th>
                        </tr>
                    </thead>

                    <tbody id="nature-body" className={"bg-white"}>
                    {
                        (limit ? data.reasonsBo.slice(0, limit) : data.reasonsBo).map((d, index) => {
                            return(
                                <tr key={index}>
                                    <td className={'w-[13%]'}>{d.percent}%</td>
                                    <td>{d.amount}</td>
                                    <td>{d.reasons}</td>
                                    <td>{d.groups}</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>

                {
                    passedLimit &&
                    <div className="text-end mt-1">
                        <span id="toggle-nature" className="see-more print-hide" onClick={seeMoreOrLess}>
                            { limit ? "Ver mais" : "Ver menos" }
                        </span>
                    </div>
                }
            </div>
            <div className="chart-divisor"></div>
        </>
    );
};

export default ReasonsContent;